var map = {
	"./caramel_berry.png": 8340,
	"./caramel_clover.png": 9209,
	"./caramel_flower.png": 1095,
	"./caramel_heart.png": 2176,
	"./caramel_ribbon.png": 7274,
	"./caramel_star.png": 710,
	"./caramel_strawberry.png": 5117,
	"./lemon_berry.png": 6,
	"./lemon_clover.png": 2779,
	"./lemon_flower.png": 2745,
	"./lemon_heart.png": 3522,
	"./lemon_ribbon.png": 616,
	"./lemon_star.png": 4584,
	"./lemon_strawberry.png": 1575,
	"./matcha_berry.png": 7201,
	"./matcha_clover.png": 4418,
	"./matcha_flower.png": 6844,
	"./matcha_heart.png": 805,
	"./matcha_ribbon.png": 7477,
	"./matcha_star.png": 6265,
	"./matcha_strawberry.png": 8422,
	"./mint_berry.png": 6013,
	"./mint_clover.png": 8830,
	"./mint_flower.png": 9248,
	"./mint_heart.png": 9353,
	"./mint_ribbon.png": 4449,
	"./mint_star.png": 1885,
	"./mint_strawberry.png": 1770,
	"./rainbow_berry.png": 7125,
	"./rainbow_clover.png": 4502,
	"./rainbow_flower.png": 2664,
	"./rainbow_heart.png": 4625,
	"./rainbow_ribbon.png": 3881,
	"./rainbow_star.png": 5,
	"./rainbow_strawberry.png": 5202,
	"./ruby_berry.png": 9697,
	"./ruby_clover.png": 8290,
	"./ruby_flower.png": 4364,
	"./ruby_heart.png": 3301,
	"./ruby_ribbon.png": 1349,
	"./ruby_star.png": 3033,
	"./ruby_strawberry.png": 9590,
	"./rubyswirl_berry.png": 5362,
	"./rubyswirl_clover.png": 4583,
	"./rubyswirl_flower.png": 5389,
	"./rubyswirl_heart.png": 998,
	"./rubyswirl_ribbon.png": 5684,
	"./rubyswirl_star.png": 3964,
	"./rubyswirl_strawberry.png": 5275,
	"./salt_berry.png": 4429,
	"./salt_clover.png": 5486,
	"./salt_flower.png": 5904,
	"./salt_heart.png": 1417,
	"./salt_ribbon.png": 1105,
	"./salt_star.png": 9661,
	"./salt_strawberry.png": 602,
	"./vanilla_003_heart.png": 2892,
	"./vanilla_004_star.png": 2199,
	"./vanilla_005_clover.png": 9507,
	"./vanilla_berry.png": 5982,
	"./vanilla_flower.png": 7857,
	"./vanilla_ribbon.png": 2816,
	"./vanilla_strawberry.png": 4447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5065;